export const PRIVATEPOLICY_REQUEST = "PRIVATEPOLICY_REQUEST";
export const PRIVATEPOLICY_RECEIVE = "PRIVATEPOLICY_RECEIVE";
export const PRIVATEPOLICY_FAILURE = "PRIVATEPOLICY_FAILURE";
export const RESET_TEST = "RESET_TEST";